import { styled } from '@customink/pigment-react/lib/themeCustomink';
import { Box } from '@customink/pigment-react';

export const SectionContent = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));
